import { mediaQuery } from './media-query';

jQuery(document).ready(() => {

    mediaQuery(
      'max',
      'width',
      '767',
      () => {
        // Mobile do anything
        //console.log('Hola soy Footer Mobile');
        languageSelector ();
      }
    );
  
  });

  function languageSelector() {
    jQuery('.js-wpml-ls-item-toggle').on('click', function(e){
        e.preventDefault();
        if ( jQuery('.js-wpml-ls-sub-menu').css('visibility') == 'hidden' )
            jQuery('.js-wpml-ls-sub-menu').css('visibility','visible');
        else
            jQuery('.js-wpml-ls-sub-menu').css('visibility','hidden');
    })
  }